import type { BookingDetails } from "@repo/ui/types/booking";
import type { GroupedStations } from "@repo/ui/types/stations";
import { getCityNameByCode } from "@repo/ui/utils/flight";

type flightData = {
  departure?: string;
  destination?: string;
  departureCode?: string;
  destinationCode?: string;
};

type HeaderResult = {
  headerOrigin: string;
  headerDestination: string;
};

/**
 * Returns the header origin and destination based on direction.
 *
 * @param bookingDetails - booking details
 * @param direction - Either "VUELTA" (return) or "IDA" (outbound)
 * @param stations - Redux stations state
 */
export function formatTravelHeader(
  bookingDetails: BookingDetails | null | undefined,
  direction?: string,
  stations?: GroupedStations | null,
): HeaderResult {
  if (!bookingDetails?.journeys?.[0]) {
    return {
      headerOrigin: "N/A",
      headerDestination: "N/A",
    };
  }

  const isReturn = direction?.toUpperCase() === "VUELTA" || direction?.toUpperCase() === "INBOUND";
  const [outbound] = bookingDetails.journeys;
  const { designator } = outbound;
  const { origin, destination } = designator;

  const departureName = stations ? getCityNameByCode(origin, stations) : "NA";
  const destinationName = stations ? getCityNameByCode(destination, stations) : "NA";

  const flightData: flightData = {
    departure: departureName || origin || "NA",
    destination: destinationName || destination || "NA",
    departureCode: origin,
    destinationCode: destination,
  };

  return {
    headerOrigin: isReturn
      ? `${flightData.destination} (${flightData.destinationCode})`
      : `${flightData.departure} (${flightData.departureCode})`,
    headerDestination: isReturn
      ? `${flightData.departure} (${flightData.departureCode})`
      : `${flightData.destination} (${flightData.destinationCode})`,
  };
}
